import type {
  SearchListSuccess,
} from '@autobid/strapi-integration/typescript/auction/searchCars'
import type { ItemDeleteEvent } from '@autobid/ui/types/websocket/ItemDeleteEvent'
import type { ItemWithdrawEvent } from '@autobid/ui/types/websocket/ItemWithdrawEvent'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  searchCarsQueryKey,
} from '@autobid/ui/composables/car/data/useSearchCars'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useSearchItemWithdrawOrDelete() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemWithdrawOrDelete = () => {
    const callback = (event: ItemWithdrawEvent | ItemDeleteEvent) => {
      randomDebounce(0, 3000, () => {
        queryClient.invalidateQueries({
          predicate: (query) => {
            if (!Array.isArray(query.queryKey))
              return false

            const searchCarsBaseQueryKey = searchCarsQueryKey.all()
            if (query.queryKey[0] !== searchCarsBaseQueryKey[0])
              return false

            const queryData = query.state
              .data as SearchListSuccess['data']['items']
            if (!queryData)
              return false

            return !!queryData.items.find(
              item => item.id === event.context.itemId,
            )
          },
        })
      })
    }

    startListen({
      eventName: 'premium.ITEM_WITHDRAW',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: event => callback(event),
    })

    startListen({
      eventName: 'premium.ITEM_DELETED',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: event => callback(event),
    })
  }

  return { itemWithdrawOrDelete }
}
